import { appInitialize } from '@/utils/app-initialize';
// import 'zone.js';
// @ts-ignore
import App from './App.vue';
import '@nio-fe/lego/lib/index.css';
import '@nio-wad/beach/dist/style.css';
import '@/assets/styles/common.scss';
import '@/assets/styles/print.scss';
import '@/assets/styles/lego-override.scss';
import '@nio-fe/brand-mix-ui/dist/style.css';
import { EnhancedCrashMonitor, CrashSimulator } from '@/crashReports';
import { getEnvironmentFromHostname } from '@/utils';
import useGlobalStore from '@/store/globalStore';
appInitialize(App)
  .then(() => {
    const globalStore = useGlobalStore();
    const user = globalStore.userInfo;
    const crashMonitor = new EnhancedCrashMonitor({
      heartbeatInterval: 1000,
      crashTimeout: 15000,
      reportEndpoint: '/client/error/reports',
      sessionId: user.domainAccount,
    });
    if (getEnvironmentFromHostname() !== 'prod') {
      const simulator = new CrashSimulator();
      window.__CRASH_SIMULATOR__ = simulator;
    }

    return crashMonitor.start();
  })
  .then(() => {
    console.log('init success');
  })
  .catch((e) => {
    console.error('init failed =>', e);
  });
